import { LegalLayout } from "@/components/LegalLayout";

export default function BookingPolicy() {
  return (
    <LegalLayout eyebrow="— Pravne informacije" title="Pravila rezervacije i otkazivanja" lastUpdated="prosinac 2025.">
      <p>
        Ova pravila opisuju kako funkcionira online rezervacija termina u salonu La Maison by FP te uvjete
        otkazivanja i pomicanja termina.
      </p>

      <h2>1. Kako rezervirati termin</h2>
      <ul>
        <li>Termin možete rezervirati online putem obrasca na stranici, telefonom na 091 612 7321 ili Instagram porukom <a href="https://instagram.com/lamaison_fp" target="_blank" rel="noreferrer">@lamaison_fp</a>.</li>
        <li>Prilikom online rezervacije unosite: osobne podatke (ime, telefon, e-mail), odabrano vrijeme i uslugu te (opcionalno) napomenu.</li>
        <li>Nakon slanja zahtjeva dobivate <strong>automatsku e-mail potvrdu primitka rezervacije</strong> — to <em>nije</em> konačna potvrda termina.</li>
        <li>Termin se smatra <strong>potvrđenim</strong> tek kada Vas kontaktiramo (e-mailom ili telefonom) i potvrdimo dostupnost.</li>
      </ul>

      <h2>2. Radno vrijeme</h2>
      <ul>
        <li>Ponedjeljak, srijeda, četvrtak: 13:00 — 20:00</li>
        <li>Utorak, petak: 08:00 — 15:00</li>
        <li>Subota: 08:00 — 14:00</li>
        <li>Nedjeljom ne radimo.</li>
      </ul>

      <h2>3. Trajanje termina</h2>
      <p>
        Trajanje pojedine usluge može varirati ovisno o duljini i stanju kose. Okvirno trajanje navedeno je
        u cjeniku, a konačno trajanje termina dogovara se prilikom potvrde.
      </p>

      <h2>4. Otkazivanje i pomicanje termina</h2>
      <p>
        Termin možete otkazati ili pomaknuti bez naknade <strong>najkasnije 24 sata prije zakazanog termina</strong>,
        nazivom na 091 612 7321 ili odgovorom na e-mail potvrde. Otkazivanje u kraćem roku otežava
        organizaciju ostalih klijenata, pa Vas molimo da nas u tom slučaju kontaktirate što ranije.
      </p>

      <h2>5. Kašnjenje</h2>
      <p>
        U slučaju kašnjenja od više od 15 minuta zadržavamo pravo skratiti uslugu ili predložiti novi termin
        kako ne bismo poremetili termine drugih klijenata. Hvala na razumijevanju.
      </p>

      <h2>6. Cijene i plaćanje</h2>
      <ul>
        <li>Cijene iz cjenika izražene su u eurima (EUR) i okvirne su za standardnu duljinu i stanje kose.</li>
        <li>Konačnu cijenu definiramo nakon analize i dogovora.</li>
        <li>Plaćanje se obavlja u salonu — gotovinski ili karticom.</li>
      </ul>

      <h2>7. Alergije i osjetljivosti</h2>
      <p>
        Prilikom rezervacije ili dolaska u salon molimo Vas da nas upozorite na sve poznate alergije, osjetljivosti
        na kemikalije te zdravstvena stanja koja mogu utjecati na izvedbu usluge (npr. trudnoća, terapija lijekovima).
      </p>

      <h2>8. Reklamacije</h2>
      <p>
        Reklamacije primamo isključivo unutar <strong>3 dana</strong> od izvršene usluge, osobno u salonu ili putem
        e-maila na <a href="mailto:lamaisonbyfp@gmail.com">lamaisonbyfp@gmail.com</a>. Trudit ćemo se ispraviti
        nepravilnost u najkraćem roku.
      </p>

      <h2>9. Kontakt</h2>
      <p>
        <strong>La Maison by FP</strong> · Matije Gupca 6, 31400 Đakovo · 091 612 7321 ·{" "}
        <a href="mailto:lamaisonbyfp@gmail.com">lamaisonbyfp@gmail.com</a>
      </p>
    </LegalLayout>
  );
}
